import React from "react";
import { styled, useTheme } from '@mui/material/styles';
import Hazard from "./Hazard";
import AnalysisType from "./AnalysisType";
import DateSort from "./AnalysisSort";
import Losses from "./Losses";

const PREFIX = 'Filters';

const classes = {
  root: `${PREFIX}-root`,
  filter: `${PREFIX}-filter`
};

const Root = styled('div')((
  {
    theme
  }
) => ({

  [`& .${classes.filter}`]: {
    margin: "0 0.25rem",
  }

}));

const Filters = () => {
	
  const theme = useTheme();

  return (
    <Root className={classes.root}
		sx={{
			display: "flex",
		    marginLeft: "-0.5em",
		    [theme.breakpoints.down("sm")]: {
		    	flexDirection: "column",
		    },
	}}>
	      <div className={classes.filter}>
	        <Hazard />
	      </div>
	      <div className={classes.filter}>
	        <AnalysisType />
	      </div>
	      <div className={classes.filter}>
	        <Losses />
	      </div>
	      <div className={classes.filter}>
	        <DateSort />
	      </div>
    </Root>
  );
};

export default Filters;
